"use strict";

angular.module("vendor")
.component("catalogEntryDiscount", {
    templateUrl: require("./catalog-entry-discount.component.html"),
    controller: catalogEntryDiscountController,
    controllerAs: "ctrl",
    bindings: {
        catalogEntry: "="
    }
});

function catalogEntryDiscountController($scope, ModalService, common, CatalogEntryService, moment) {
    var _this = this;
    $scope.nowISOString = moment().toISOString();

    this.editDiscount = function() {
        var price = (_this.catalogEntry.price) ? _this.catalogEntry.price : _this.catalogEntry.product.StandardPrice;

        ModalService.showModal({
            templateUrl: require("./catalog-entry-discount.modal.html"),
            controller: "CatalogEntryDiscountModalController",
            controllerAs: "ctrl",
            inputs: {
                $attrs: {
                    discount: angular.copy(_this.catalogEntry.discount),
                    price: price
                }
            }
        }).then(function(modal) {
            modal.element.modal({
                backdrop: "static",
                keyboard: false
            });
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function(result) {
                if (result.discount) {
                    CatalogEntryService.patchField(_this.catalogEntry.id, {
                        discount: result.discount
                    }).then(function(data) {
                        _this.catalogEntry = data;
                    });
                }
                if (result.deleted) {
                    _this.catalogEntry.discount = null;
                }
            });
        });
    };

}



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/catalog/catalog-entry-tab/catalog-entry-discount/catalog-entry-discount.component.js
// module id = 954
// module chunks = 0